module.exports = __webpack_public_path__ + "static/media/lohono-logo-dark.98de2b03.webp";